import React, { lazy } from "react";
import { docLazyFn } from '@/router/untilFn'

// 沙盒-导航栏
import SandBox from '@/components/SandBox'

// Home
import Home from '@/views/Home'

const home = [ 
  {
    path: "/home",
    element: <SandBox />,
    children: [
      {
        path: "index",
        element: docLazyFn(<Home />),
      }
    ],
  }
];

export default home;
